const FloatingMenu = {
  init() {
    this.events();
    this.loader();
  },

  events() {
    const menuEl = $(".floating-menu");
    const openBtn = $(".floating-menu__open-btn");
    const closeBtn = $(".floating-menu__close-btn");

    openBtn.on("click", () => {
      menuEl.toggleClass("open");
    });

    closeBtn.on("click", () => {
      menuEl.toggleClass("open");
    });

    $(document).on('mouseup', ".floating-menu__nav-item", function (e) {
      let sectionSlug = $(e.currentTarget).data("section");

      let target = $('section[data-fm-slug="' + sectionSlug + '"]');

      if (target.length) {
        $("html, body").animate(
          {
            scrollTop: target.offset().top - 100,
          },
          200
        );
      }
      menuEl.toggleClass("open");
    });

    // Next and prev arrows
    $('.floating-menu__next-btn').on('click', () => this.handleNavigation(true));
    $('.floating-menu__previous-btn').on('click', () => this.handleNavigation(false));
  },

  loader() {
    const anchors = $('*[data-fm-name]');

    if (!anchors.length) {
      return;
    } else {
      $('.floating-menu').removeClass('hidden');
    }

    anchors.each(function () {
      const name = $(this).data('fm-name');
      const slug = $(this).data('fm-slug');

      const output = `<li><button data-section="${slug}" class="floating-menu__nav-item">${name}</button></li>`;

      $('.floating-menu__nav ul').append(output);
    });

    this.scrollHandler();
  },

  scrollHandler() {
    $(window).on('scroll', function () {
      let scrollPosition = $(window).scrollTop();
      let currentSection = null;

      $('*[data-fm-name]').each(function () {
        var section = $(this);
        var sectionTop = section.offset().top - 100;
        var sectionHeight = section.height();

        if (scrollPosition >= sectionTop && scrollPosition < (sectionTop + sectionHeight)) {
          currentSection = section;
        }
      });

      if (currentSection && !currentSection.hasClass('current')) {
        currentSection.addClass('current');
        $('*[data-fm-name]').not(currentSection).removeClass('current');
      }

      //Arrow buttons inactive class
      let currentEl = $('[data-fm-name].current');
      if (!currentEl.length) {
        currentEl = $('[data-fm-name]').first();
      };
      let next = currentEl.nextAll('[data-fm-name]').first();
      let prev = currentEl.prevAll('[data-fm-name]').first();

      if (!next.length) {
        $('.floating-menu__next-btn').addClass('inactive');
      } else {
        $('.floating-menu__next-btn').removeClass('inactive');
      }

      if (!prev.length) {
        $('.floating-menu__previous-btn').addClass('inactive');
      } else {
        $('.floating-menu__previous-btn').removeClass('inactive');
      }
    });
  },

  scrollTo(element) {
    if (element.length) {
      $("html, body").animate(
        {
          scrollTop: element.offset().top - 100,
        },
        200
      );
    }
  },

  handleNavigation(isNext) {
    let currentEl = $('[data-fm-name].current');

    let targetEl = isNext
      ? currentEl.nextAll('[data-fm-name]').first()
      : currentEl.prevAll('[data-fm-name]').first();

    if (!currentEl.length) {
      targetEl = $('[data-fm-name]').first();
    };
    if (targetEl.length) {
      this.scrollTo(targetEl);
      setTimeout(() => {
        currentEl.removeClass('current');
        targetEl.addClass('current');
      }, 600);
    }
  },
};

export default FloatingMenu;
